var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.model)?_c('apexchart',{attrs:{"width":"800","type":"bar","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }